import { render } from "./TableAuditColumns.vue?vue&type=template&id=7fc2a4d8&scoped=true&ts=true"
import script from "./TableAuditColumns.vue?vue&type=script&lang=ts"
export * from "./TableAuditColumns.vue?vue&type=script&lang=ts"

import "./TableAuditColumns.vue?vue&type=style&index=0&id=7fc2a4d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc2a4d8"]])

export default __exports__